__turbopack_context__.v({
  "Large": "Link-module__t7I7EW__Large",
  "clamp": "Link-module__t7I7EW__clamp" + " " + __turbopack_context__.i(7213)["lineClamp"],
  "hoverIFrame": "Link-module__t7I7EW__hoverIFrame",
  "hoverIFrameWrapper": "Link-module__t7I7EW__hoverIFrameWrapper",
  "newTabIcon": "Link-module__t7I7EW__newTabIcon",
  "pressDown": "Link-module__t7I7EW__pressDown",
  "release": "Link-module__t7I7EW__release",
  "root": "Link-module__t7I7EW__root",
});
